// extracted by mini-css-extract-plugin
module.exports = {"section":"TextButton_section__0nCTf","shortDescription":"TextButton_shortDescription__8wQXm"};